export const getValidationRules = (field) => {
  const rules = [];
  if (field.validation?.required) {
    const val = typeof field.validation.required === "object" ? field.validation.required.value : field.validation.required;
    if (val === true)
      rules.push("required");
  }
  if (field.validation?.email) {
    const val = typeof field.validation.email === "object" ? field.validation.email.value : field.validation.email;
    if (val === true)
      rules.push("email");
  }
  if (field.validation?.min) {
    const val = typeof field.validation.min === "object" ? field.validation.min.value : field.validation.min;
    if (typeof val === "number")
      rules.push(`min:${val}`);
  }
  if (field.validation?.max) {
    const val = typeof field.validation.max === "object" ? field.validation.max.value : field.validation.max;
    if (typeof val === "number")
      rules.push(`max:${val}`);
  }
  if (field.validation?.min_value) {
    const val = typeof field.validation.min_value === "object" ? field.validation.min_value.value : field.validation.min_value;
    if (typeof val === "number")
      rules.push(`min_value:${val}`);
  }
  if (field.validation?.max_value) {
    const val = typeof field.validation.max_value === "object" ? field.validation.max_value.value : field.validation.max_value;
    if (typeof val === "number")
      rules.push(`max_value:${val}`);
  }
  if (field.validation?.pattern) {
    const val = typeof field.validation.pattern === "object" ? field.validation.pattern.value : field.validation.pattern;
    if (val instanceof RegExp) {
      rules.push(`regex:${val.source}`);
    } else if (typeof val === "string") {
      rules.push(`regex:${val}`);
    }
  }
  if (field.validation?.numeric) {
    const val = typeof field.validation.numeric === "object" ? field.validation.numeric.value : field.validation.numeric;
    if (val === true)
      rules.push("numeric");
  }
  if (field.validation?.one_of) {
    const val = typeof field.validation.one_of === "object" ? field.validation.one_of.value : field.validation.one_of;
    if (typeof val === "string")
      rules.push(`oneOf:${val}`);
    else if (Array.isArray(val))
      rules.push(`oneOf:${val.join(",")}`);
  }
  return rules.join("|");
};
export const getValidationMessages = (field) => {
  const messages = {};
  if (field.validation?.required && typeof field.validation.required === "object" && field.validation.required.error_message) {
    messages.required = field.validation.required.error_message;
  }
  if (field.validation?.email && typeof field.validation.email === "object" && field.validation.email.error_message) {
    messages.email = field.validation.email.error_message;
  }
  if (field.validation?.min && typeof field.validation.min === "object" && field.validation.min.error_message) {
    messages.min = field.validation.min.error_message;
  }
  if (field.validation?.max && typeof field.validation.max === "object" && field.validation.max.error_message) {
    messages.max = field.validation.max.error_message;
  }
  if (field.validation?.min_value && typeof field.validation.min_value === "object" && field.validation.min_value.error_message) {
    messages.min_value = field.validation.min_value.error_message;
  }
  if (field.validation?.max_value && typeof field.validation.max_value === "object" && field.validation.max_value.error_message) {
    messages.max_value = field.validation.max_value.error_message;
  }
  if (field.validation?.pattern && typeof field.validation.pattern === "object" && field.validation.pattern.error_message) {
    messages.regex = field.validation.pattern.error_message;
  }
  if (field.validation?.numeric && typeof field.validation.numeric === "object" && field.validation.numeric.error_message) {
    messages.numeric = field.validation.numeric.error_message;
  }
  if (field.validation?.one_of && typeof field.validation.one_of === "object" && field.validation.one_of.error_message) {
    messages.oneOf = field.validation.one_of.error_message;
  }
  return messages;
};
